import React, { useContext, useEffect } from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import EditForm from './components/EditForm/EditForm';
import TranslationsForm from './components/TranslationsForm/TranslationsForm';
import { EditGameContext, IEditGameContext } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditGameContext>(EditGameContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<WithAdditionalValidationState>
				<EditForm isVisible={visibleForm === 'mainForm'} />
				<TranslationsForm isVisible={visibleForm === 'translations'} />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Forms;
